import { gameLiveConnection } from '../services';
import { winBarStore } from '../store/winBarStore';
import { gambleStore } from '../store/gambleStore';
import { userInfoStore } from '../store/userInfoStore';
import { applicationStore } from '../store/applicationStore';
import { parseNumberByPrecision } from './parseNumberByPrecision';
import { gameMainDrawer } from '../game/drawers/gameMainDrawer';
import { spinBarStore } from '../store/spinBarStore';
import { DefaultQueryParams } from '../constants/defaultQueryParams';
import { parseQuery } from './parseQuery';

export const getDemoBalance = () => {
  const winAmount = gambleStore.isGamble ? gambleStore.gambleTotalWinAmount : winBarStore.winAmount;
  userInfoStore.setDemoBalance(
    parseNumberByPrecision(userInfoStore.demoBalance + winAmount, 1, userInfoStore.precision)
  );
  gameMainDrawer.menuBar.updateUserBalance();
};

export const balanceUpdateHandler = () => {
  if (spinBarStore.tournamentId) {
    const {
      [DefaultQueryParams.GameId]: gameId,
      [DefaultQueryParams.TournamentId]: tournamentId,
      [DefaultQueryParams.PartnerId]: partnerId,
    } = parseQuery(window.location.search);
    gameLiveConnection.getTournamentBalance({ gameId, partnerId, tournamentId });
    return;
  }
  if (applicationStore.isDemo) {
    getDemoBalance();
  } else if (winBarStore.winAmount) {
    gameLiveConnection.getBalance();
  }
};
